import moment from 'moment';

const capitalizeFirstCharacter = (inputString) => {
  return inputString.charAt(0).toUpperCase() + inputString.slice(1);
};

export default (timeFromX = 0) => {
  return capitalizeFirstCharacter(moment(timeFromX).fromNow());
};
